module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"recipients":"Patients","loading":"...loading"},"fr":{"recipients":"Patients","loading":"...chargement en cours"}}')
  delete Component.options._Ctor
}
